import type { Lang } from '../i18n'

const GUIDE_URL: Record<Lang, string> = { en: '/connect/meta/en/', ru: '/connect/meta/', uk: '/connect/meta/ua/' }

/** The customer guide for Meta portfolio access (GRO-98): Russian at the root, English under `en/`, Ukrainian under `ua/`. */
export function metaGuideUrl(lang: Lang): string {
  return GUIDE_URL[lang]
}
